import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-up-circle",
  "use": "icon-a-up-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up-circle\" id=\"icon-a-up-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><polyline points=\"16 12 12 8 8 12\" /><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol